import { CHARACTER_WHITESPACE } from '../../../../../constants/common'
import { getCalendarCapWarningText } from '../../../Calendar.utils'

export function getCalendarViewFollowUpUncheckedMoveText({
  dayLoad,
  locale,
  t,
}) {
  return dayLoad.is_full
    ? [
        t('Calendar.LoadCheckFailedKey'),
        getCalendarCapWarningText({ dayLoad, locale, t }),
      ].join(CHARACTER_WHITESPACE)
    : t('Calendar.LoadCheckFailedKey')
}
